export enum PowerEstimationType {
  Off = 1,
  Force = 2,
  Speed = 3
}
